import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="7.5" r="5" stroke="#262626" stroke-width="2" />
    <path
      d="M20.5 19C20.5 20.6569 16.6944 21.5 12 21.5C7.30558 21.5 3.5 20.6569 3.5 19C3.5 17.3431 7.30558 15.5 12 15.5C16.6944 15.5 20.5 17.3431 20.5 19Z"
      stroke="#262626"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
);

const activedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 1.5C8.68629 1.5 6 4.18629 6 7.5C6 10.8137 8.68629 13.5 12 13.5C15.3137 13.5 18 10.8137 18 7.5C18 4.18629 15.3137 1.5 12 1.5ZM12 14.5C9.5324 14.5 7.26961 14.9827 5.59131 15.7114C4.75521 16.0745 4.02246 16.5166 3.48174 17.0268C2.95533 17.5234 2.5 18.1944 2.5 19C2.5 19.8521 3.00399 20.4806 3.58076 20.899C4.15078 21.3126 4.90473 21.6128 5.72742 21.8363C7.38544 22.2868 9.60881 22.5 12 22.5C14.3912 22.5 16.6146 22.2868 18.2726 21.8363C19.0953 21.6128 19.8492 21.3126 20.4192 20.899C20.996 20.4806 21.5 19.8521 21.5 19C21.5 18.1944 21.0447 17.5234 20.5183 17.0268C19.9775 16.5166 19.2448 16.0745 18.4087 15.7114C16.7304 14.9827 14.4676 14.5 12 14.5Z"
      fill="url(#paint0_linear_18903_5882)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_18903_5882"
        x1="5.5"
        y1="3.15524"
        x2="22.5748"
        y2="19.1277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5891FF" />
        <stop offset="1" stop-color="#3768FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconUserOperate() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
